// eslint-disable-next-line import/prefer-default-export
export const daysPerWeek = 7;
